import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import { useWorkExperience } from "../../hooks/usePortfolioData";
import "./WorkExperience.css";

function WorkExperience() {
  const { workExperience, loading, error } = useWorkExperience();

  if (loading) {
    return (
      <Container>
        <div className="text-center" style={{ color: "white", padding: "20px" }}>
          Loading work experience...
        </div>
      </Container>
    );
  }

  if (error || !workExperience || workExperience.length === 0) {
    return null; // Don't show anything if no work experience
  }

  const formatDate = (dateString) => {
    if (!dateString) return 'Present';
    const date = new Date(dateString);
    return date.toLocaleDateString('en-US', { month: 'short', year: 'numeric' });
  };

  const isCurrentJob = (endDate) => {
    return !endDate || endDate === null;
  };

  return (
    <Container style={{ paddingTop: "50px", paddingBottom: "50px" }}>
      <h1 className="project-heading">
        Work <strong className="purple">Experience</strong>
      </h1>
      <div className="timeline-container">
        {workExperience.map((exp, index) => (
          <div key={exp.id} className="timeline-item">
            <div className="timeline-marker"></div>
            <div className="timeline-content">
              <div className="timeline-header">
                <div style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'flex-start', marginBottom: '0.5rem' }}>
                  <div>
                    <h3 className="timeline-job-title">{exp.job_title}</h3>
                    {exp.company_website ? (
                      <a 
                        href={exp.company_website} 
                        target="_blank" 
                        rel="noopener noreferrer" 
                        className="timeline-company"
                        style={{ textDecoration: 'none' }}
                      >
                        {exp.company} 🔗
                      </a>
                    ) : (
                      <span className="timeline-company">{exp.company}</span>
                    )}
                    {exp.location && (
                      <span className="timeline-location"> • {exp.location}</span>
                    )}
                  </div>
                  <span className="employment-type-badge">
                    {exp.employment_type || 'Full-time'}
                  </span>
                </div>
              </div>
              <div className="timeline-date">
                {formatDate(exp.start_date)} - {isCurrentJob(exp.end_date) ? (
                  <span className="current-badge">Present</span>
                ) : (
                  formatDate(exp.end_date)
                )}
              </div>
              {exp.description && (
                <div 
                  className="timeline-description"
                  dangerouslySetInnerHTML={{ __html: exp.description }}
                />
              )}
              {exp.technologies && (
                <div className="timeline-technologies">
                  <strong>Technologies: </strong>
                  {exp.technologies.split(',').map((tech, i) => (
                    <span key={i} className="tech-tag">
                      {tech.trim()}
                    </span>
                  ))}
                </div>
              )}
            </div>
          </div>
        ))}
      </div>
    </Container>
  );
}

export default WorkExperience;

